const DASH = "—"

export function buildTaskMetadataRows(task = {}, { frequencyLabel, durationLabel } = {}) {
    return [
        { label: "Criticality", value: formatCriticality(task.classification) },
        { label: "Frequency", value: frequencyLabel || DASH },
        { label: "Duration", value: durationLabel || DASH },
        { label: "Skill", value: formatSkill(task) },
    ]
}

function formatCriticality(classification) {
    if (classification == null || classification === "") return DASH
    return String(classification)
}

function formatSkill(task) {
    return task?.skill?.Skilling || task?.skill?.SkillingCode || task?.skillSet || DASH
}
